import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SupportProvider } from "@/context/SupportContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { DigitalRain } from "@/components/DigitalRain";
import Landing from "@/pages/Landing";
import AuthCallback from "@/pages/AuthCallback";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import Room from "@/pages/Room";
import Admin from "@/pages/Admin";

function AppRouter() {
  const location = useLocation();
  const { user } = useAuth();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/dashboard" element={<ProtectedRoute>{user?.role === "admin" ? <Navigate to="/admin" replace /> : <Dashboard />}</ProtectedRoute>} />
      <Route path="/room/:roomId" element={<ProtectedRoute><Room /></ProtectedRoute>} />
      <Route path="/admin" element={<ProtectedRoute adminOnly><Admin /></ProtectedRoute>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App relative min-h-screen overflow-x-hidden">
      <DigitalRain />
      <div className="noise-overlay" aria-hidden />
      <AuthProvider>
        <SupportProvider>
          <BrowserRouter>
            <div className="relative z-10">
              <AppRouter />
            </div>
          </BrowserRouter>
        </SupportProvider>
        <Toaster position="bottom-right" />
      </AuthProvider>
    </div>
  );
}
